module.exports = __webpack_public_path__ + "assets/img/team.3008e8c2.png";